import { useState } from 'react'
import { fetcher, AdminSeasonsEndpoints, IUseSeasons } from '@olagg/api-hooks'
import { AdminSeason } from '@olagg/db-types'

interface SeasonsResponse {
  gameSeasons: AdminSeason[]
  meta: {
    count: number
  }
}

const useSeasons = () => {
  const [loading, setLoading] = useState(false)

  const getSeasons = async (filter: IUseSeasons): Promise<SeasonsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching seasons:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getSeason = async (id: string): Promise<AdminSeason> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.find(id)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching season:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createSeason = async (data: Partial<AdminSeason>): Promise<AdminSeason> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating season:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const cloneSeason = async (id: string): Promise<AdminSeason> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.clone(id)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error cloning season:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateSeason = async (id: string, data: Partial<AdminSeason>): Promise<AdminSeason> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.update(id, data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error updating season:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteSeason = async (id: string): Promise<void> => {
    try {
      setLoading(true)
      const endpoint = AdminSeasonsEndpoints.delete(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error deleting season:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getSeasons,
    getSeason,
    createSeason,
    cloneSeason,
    updateSeason,
    deleteSeason
  }
}

export default useSeasons
